import slsDashboardImg from "../../../../src/blog/2017-04-02 - What is Serverless computing/assets/serverless-dashboard.gif";
import React from 'react';
export default {
  slsDashboardImg,
  React
};